import cx from "classnames"
import React from "react"
import { P1 } from "components/Typography"
import * as css from "./HistorySection.module.css"
import maxCalloutGraphic from "./max-callout.jpg"
import supersetGraphic from "./superset.png"
import Section from "components/Layout/Section"
import SectionHeader from "components/Layout/SectionHeader"

function HistorySection() {
  return (
    <Section className={css.section}>
      <div
        className={cx(
          "grid grid-cols-1 md:grid-cols-[11fr_5fr] gap-8 items-center",
          css.grid
        )}
      >
        <div>
          <SectionHeader title="Preset’s Origin Story" level="h1" />
          <P1>
            Superset, the open-source project underpinning Preset, started life
            as a hackathon project at Airbnb in the summer of 2015. The goal was
            to build an open- source application to enable users to slice, dice,
            and visualize data out of Apache Druid, an up-and-coming, blazing
            fast, realtime, distributed in-memory database. Superset grew
            quickly, taking on more and more use cases, eventually surpassing
            Tableau as Airbnb’s main data visualization solution. Superset was
            established as a full-fledged open- source project, incubating with
            the Apache Software Foundation, in 2016. Today Superset is the
            leading open- source analytics platform, with one of the fastest
            growing communities on GitHub and enterprise users at data-hungry
            companies like Airbnb, Lyft and Twitter.
          </P1>
        </div>
        <div>
          <img
            src={supersetGraphic}
            alt="Apache Superset™ is used by leading companies such as Lyft, Twitter, and Airbnb."
            className={css.image}
            width={364}
          />
        </div>
      </div>
      <div
        className={cx(
          "grid grid-cols-1 md:grid-cols-[11fr_5fr] gap-8 items-center",
          css.grid,
          css.aboutMax
        )}
      >
        <div>
          <P1>
            Max Beauchemin has worked at the leading edge of data and analytics
            his entire career, helping shape the discipline in influential roles
            at data-dependent companies like Yahoo!, Facebook, Airbnb, and Lyft.
            A leader in the open- source community, Max is the original creator
            of Apache Airflow, an open-source tool for orchestrating complex
            computational workflows and data processing pipelines and Apache
            Superset, the popular open- source project underpinning Preset.
          </P1>
        </div>
        <div>
          <img
            src={maxCalloutGraphic}
            alt="Max Beauchemin, Preset’s founder."
            className={css.image}
            width={330}
          />
        </div>
      </div>
    </Section>
  )
}

export default HistorySection
